import MuiRadio from '@material-ui/core/Radio';
import PropTypes from 'prop-types';

import IconRadioChecked from 'src/assets/icons/RadioChecked';
import IconRadioDefault from 'src/assets/icons/RadioDefault';

import { useStyles } from './useStyles';

const Radio = ({ strokeColor, ...restProps }) => {
  const styles = useStyles();

  return (
    <MuiRadio
      classes={styles}
      icon={<IconRadioDefault strokeColor={strokeColor} />}
      checkedIcon={<IconRadioChecked />}
      color="primary"
      {...restProps}
    />
  );
};

Radio.propTypes = {
  strokeColor: PropTypes.string,
};
Radio.defaultProps = {
  strokeColor: null,
};

export default Radio;
